/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-26T11:31:09.444
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportRentContractRequestCheckoutLease,
	getReportRentContractRequestCheckoutLeaseCreateInit,
	getReportRentContractRequestCheckoutLeaseEditInit,
	getReportRentContractRequestCheckoutLeaseView,
	deleteReportRentContractRequestCheckoutLease
} from '@api/report/ReportRentContractRequestCheckoutLease';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportRentContractRequestCheckoutLeaseCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestCheckoutLeaseCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportRentContractRequestCheckoutLeaseEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestCheckoutLeaseEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportRentContractRequestCheckoutLease({}, ReportRentContractRequestCheckoutLease) {
			return new Promise((resolve, reject) => {
				saveReportRentContractRequestCheckoutLease(ReportRentContractRequestCheckoutLease)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportRentContractRequestCheckoutLeaseView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestCheckoutLeaseView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportRentContractRequestCheckoutLease({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractRequestCheckoutLease({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
